import { realBricksApi } from '../../utils/axiosInterceptors';

export const getLegalPolicyListService = () => {
  return realBricksApi.get(`/api/v1/legal/master`);
};

export const getPolicyByEnumService = (title) => {
  return realBricksApi.get(`/api/v1/legal/${title}`);
};
